import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
  Button,
  FormControl,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import CustomDataCard from "../../components/CustomDataCard";
import { formatCurrency } from "../../utils/utils";
import {
  get_receipt_list,
  delete_receipt,
  add_receeipt,
} from "../../redux/receiptSlice";

const Receipt = () => {
  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [showForm, setShowForm] = useState(false); // 👈 Toggle state for form

  const [form, setForm] = useState({
    userid: "",
    voucher_date: "",
    amount: "",
    payment_mode: "",
    transaction_number: "",
    mode_of_transaction: "",
    narration: "",
    orderid: "",
  });

  const { receipt_list, total_receipt_count } = useSelector(
    (state) => state.receipt
  );

  useEffect(() => {
    store.dispatch(get_receipt_list({ page: page, limit: rows }));
  }, [page, rows]);

  const onPrevious = () => {
    if (page > 1) {
      setPage(page - 1);
      setInitialValue(initialValue - rows);
    }
  };

  const onNext = () => {
    if (rows * page < total_receipt_count) {
      setPage(page + 1);
      setInitialValue(initialValue + rows);
    }
  };

  const handleDelete = (id) => {
    store.dispatch(delete_receipt(id));
  };

  const handleAddReceipt = () => {
    const payload = {
      ...form,
      orderid: form.orderid.split(",").map((id) => id.trim()),
    };

    store.dispatch(add_receeipt(payload)).then(() => {
      store.dispatch(get_receipt_list({ page, limit: rows }));
      setForm({
        userid: "",
        voucher_date: "",
        amount: "",
        payment_mode: "",
        transaction_number: "",
        mode_of_transaction: "",
        narration: "",
        orderid: "",
      });
      setShowForm(false); // hide form after adding
    });
  };

  const createReceiptCardData = (receipt) => [
    { key: "Receipt ID", value: receipt.sr_no },
    { key: "Customer Name", value: receipt.customer_name },
    { key: "Voucher Date", value: receipt.voucher_date },
    { key: "Amount", value: formatCurrency(receipt.amount) },
    { key: "To Received", value: receipt.paid_to },
    { key: "Payment Mode", value: receipt.payment_mode },
    { key: "Transaction Number", value: receipt.transaction_number },
    { key: "Narration", value: receipt.narration },
    {
      key: "Orders",
      value: receipt.orders.map((order) => order.orderid).join(", "),
    },
  ];

  const filteredReceipts = (receipt_list || []).filter(
    (receipt) =>
      receipt &&
      (
        receipt.sr_no?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        receipt.customer_name?.toLowerCase().includes(searchQuery.toLowerCase())
      )
  );

  return (
    <>
      {/* Top Bar */}
      <Card
  bg="#fff"
  paddingInline={5}
  paddingBlock={2}
  flexDirection={["column", "column", "row"]}
  alignItems={["stretch", "stretch", "center"]}
  gap={3}
  mb={4}
  flexWrap="wrap"
>
  <Heading fontSize="xl">Receipts</Heading>

  <Spacer display={["none", "none", "block"]} />

  <Flex
    direction={["column", "column", "row"]}
    align="stretch"
    gap={3}
    w="full"
  >
    <Select
      size="md"
      value={rows}
      onChange={(e) => {
        setRows(Number(e.target.value));
        setPage(1);
        setInitialValue(1);
      }}
      w={["100%", "100%", "auto"]}
    >
      <option value="5">5</option>
      <option value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </Select>

    <InputGroup
      bg="#f4f5f7"
      borderRadius={5}
      w={["100%", "100%", "auto"]}
      maxW="sm"
    >
      <Input
        placeholder="Search ....."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <InputRightElement>
        <FiSearch />
      </InputRightElement>
    </InputGroup>

    <Button
      w={["100%", "100%", "auto"]}
      px={6}
      py={2.5}
      fontSize="sm"
      colorScheme="blue"
      onClick={() => setShowForm(!showForm)}
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow="ellipsis"
    >
      {showForm ? "Close Form" : "Add Receipt"}
    </Button>
  </Flex>
</Card>

{showForm && (
  <Card p={5} mb={4}>
    <FormControl>
      <Flex gap={3} flexWrap="wrap" flexDirection="column">
        <Input
          placeholder="User ID"
          value={form.userid}
          onChange={(e) => setForm({ ...form, userid: e.target.value })}
        />
        <Input
          type="date"
          value={form.voucher_date}
          onChange={(e) =>
            setForm({ ...form, voucher_date: e.target.value })
          }
        />
        <Input
          placeholder="Amount"
          type="number"
          value={form.amount}
          onChange={(e) => setForm({ ...form, amount: e.target.value })}
        />
        <Select
          placeholder="Payment Mode"
          value={form.payment_mode}
          onChange={(e) =>
            setForm({ ...form, payment_mode: e.target.value })
          }
        >
          <option value="Cash">Cash</option>
          <option value="Online">Online</option>
        </Select>
        <Input
          placeholder="Transaction Number"
          value={form.transaction_number}
          onChange={(e) =>
            setForm({ ...form, transaction_number: e.target.value })
          }
        />
        <Input
          placeholder="Mode of Transaction"
          value={form.mode_of_transaction}
          onChange={(e) =>
            setForm({ ...form, mode_of_transaction: e.target.value })
          }
        />
        <Input
          placeholder="Narration"
          value={form.narration}
          onChange={(e) =>
            setForm({ ...form, narration: e.target.value })
          }
        />
        <Input
          placeholder="Order IDs (comma-separated)"
          value={form.orderid}
          onChange={(e) =>
            setForm({ ...form, orderid: e.target.value })
          }
        />
        <Button colorScheme="green" onClick={handleAddReceipt}>
          Submit Receipt
        </Button>
      </Flex>
    </FormControl>
  </Card>
)}

      {/* Receipt List */}
      <SimpleGrid minChildWidth="xs" spacing="10px">
        {filteredReceipts?.map((receipt) => (
          <CustomDataCard
            key={receipt.id}
            data={createReceiptCardData(receipt)}
            keyWidth="100px"
            keyColor="gray.700"
            valueColor="gray.600"
            hoverEffect={true}
            showButton
            buttonText="Delete"
            onButtonClick={() => handleDelete(receipt.id)}
          />
        ))}
      </SimpleGrid>

      {/* Pagination */}
      <Card
        alignItems={"center"}
        gap={3}
        flexDirection={"row"}
        mt={4}
        justifyContent={"center"}
        padding={3}
      >
        <FiChevronLeft
          cursor={"pointer"}
          color={page === 1 ? "gray" : "#007bc9"}
          size={35}
          onClick={onPrevious}
        />
        <Flex gap={3} alignItems={"center"}>
          <Text>{initialValue}</Text>-
          <Text>{Math.min(rows * page, total_receipt_count)}</Text>
          <Text>of</Text>
          <Text>{total_receipt_count}</Text>
        </Flex>
        <FiChevronRight
          cursor={"pointer"}
          color={rows * page >= total_receipt_count ? "gray" : "#007bc9"}
          size={35}
          onClick={onNext}
        />
      </Card>
    </>
  );
};

export default Receipt;
